import { render, staticRenderFns } from "./privacidad.vue?vue&type=template&id=36407f29"
import script from "./privacidad.vue?vue&type=script&lang=js"
export * from "./privacidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports